import React, { useState } from "react";
import "./LearningJourney.css";
import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabsUnstyled from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./AzureLearningJourney.css";

const AzureLearningJourney = () => {
 const [value, setValue] = useState("1");

 const handleChange = (event, newValue) => {
  setValue(newValue);
 };
 return (
  <>
   <div className="learning-Journey-container">
    <h2>Azure Learning Journey</h2>
    <div className="lj-menu-wrapper">
     <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
       <Box>
        <TabList
         role="tablist"
         onChange={handleChange}
         className="main-list"
         variant="scrollable"
         scrollButtons="auto"
         aria-label="lab API tabs example"
        >
         <Tab label="Overall" value="1" className="list1 item" role="tab" />
         <Tab label="Aware" value="2" className="list2 item" role="tab" />
         <Tab label="Equipped" value="3" className="list3 item" role="tab" />
         <Tab label="Competent" value="4" className="list4 item" role="tab" />
         {/* <Tab label="Expert" value="5" className='list5 item'/> */}
        </TabList>
       </Box>
       <div className="lj-box">
        <TabPanel value="1" className="comingsoon" role="tabpanel">
         <a
          href="https://connectedlearning.accenture.com/topics/microsoft-azure-paas-and-azure-data-services"
          target="_blank"
         >
          <img
           src="images/Azure/Azure-Overall.png"
           alt="overall-img"
           className="lj-images"
          />
         </a>
        </TabPanel>
        <TabPanel value="2" className="comingsoon" role="tabpanel">
         <div className="LJ-link-Wrapp">
          {/* <img src='images/Azure/LearningJourney/Aware/Azure-AWARE-BG.png' alt='equipped-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='AzureAware'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/courses/adcdc550-5c08-41f8-a8a5-96af8e0afb89/videos/51320d28-652d-4083-a2d7-78755fcc4538" target="_blank"><img src='images/Azure/LearningJourney/Aware/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/2d413400-848f-4879-a553-93a7637ccdcf/videos/11adf76b-8608-4d1b-8365-716bf71888de" target="_blank"><img src='images/Azure/LearningJourney/Aware/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/4c88b390-4942-4ac4-a2f5-35bfc32cddf1/videos/7330262c-2df0-4276-81b6-07d9815e7024" target="_blank"><img src='images/Azure/LearningJourney/Aware/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/courses/8de2160d-382d-4846-8f59-563c74308c75/videos/59c349db-7f2a-474b-b50e-1debc84f28eb" target="_blank"><img src='images/Azure/LearningJourney/Aware/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/9b548a41-6246-40af-afa2-63df66024932/videos/cfa84dd5-a8d1-4d8a-a8b2-cb5cf6df62ec" target="_blank"><img src='images/Azure/LearningJourney/Aware/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/courses/33ed05c0-1807-11e9-9cb3-73676ac7ed55/videos/b2be1470-1807-11e9-9cb3-73676ac7ed55" target="_blank"><img src='images/Azure/LearningJourney/Aware/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://accenture.percipio.com/courses/5ae49467-7778-4f06-8584-76d44f57b011/videos/80174f42-2e54-44db-99be-23de8d4b202c" target="_blank"><img src='images/Azure/LearningJourney/Aware/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://accenture.percipio.com/courses/4ac2bef7-bd22-4688-91d2-db7230e7ad00/videos/a30ebe7b-1f46-43f5-8294-9d0d16960f82" target="_blank"><img src='images/Azure/LearningJourney/Aware/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://accenture.percipio.com/courses/bd1b304b-fd22-42c8-ae50-770bbfd35eba/videos/8f84e0f4-2ae5-4f5c-b26b-07a7407fe30d" target="_blank"><img src='images/Azure/LearningJourney/Aware/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/courses/8aa50590-198b-11e9-97aa-c10294786b6d/videos/a7981020-198b-11e9-97aa-c10294786b6d" target="_blank"><img src='images/Azure/LearningJourney/Aware/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/linked-contents/7bc5c1e4-92e8-4d5c-852b-a4e0fb0731e0/landing" target="_blank"><img src='images/Azure/LearningJourney/Aware/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://accenture.percipio.com/courses/68aff9a6-040c-463d-9b00-952474b210d0/videos/d6999271-0bc6-483a-bbd2-828d14662cf5" target="_blank"><img src='images/Azure/LearningJourney/Aware/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a href="https://accenture.percipio.com/courses/20b67a11-f7d2-4345-9ca2-f1c05949ed08/videos/8ba4f543-f5a9-4cee-bb4a-6cacda0db993" target="_blank"><img src='images/Azure/LearningJourney/Aware/13.png'/></a>
                    </p>
                    <p className='link14'>
                      <a href="https://accenture.percipio.com/courses/20b67a11-f7d2-4345-9ca2-f1c05949ed08/videos/0dbc20ea-cc0f-41c2-9e1e-bf8c32a04672" target="_blank"><img src='images/Azure/LearningJourney/Aware/14.png'/></a>
                    </p>
                    <p className='link15'>
                      <a href="https://accenture.percipio.com/linked-contents/7bc5c1e4-92e8-4d5c-852b-a4e0fb0731e0/landing" target="_blank"><img src='images/Azure/LearningJourney/Aware/15.png'/></a>
                    </p>
                  </div>
                  </div> */}
          <a
           href="https://connectedlearning.accenture.com/learningboard/1183757-microsoft-azure-paas-and-azure-data-services-aware"
           target="_blank"
          >
           <img
            src="images/Azure/LearningJourney/Azure-AWARE.png"
            alt="Azure-Aware-img"
            className="lj-images"
           />
          </a>
         </div>
        </TabPanel>
        <TabPanel value="3" className="comingsoon" role="tabpanel">
         <div className="LJ-link-Wrapp">
          {/* <img src='images/Azure/LearningJourney/Equipped/Azure-Equipped-BG.png' alt='equipped-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='AzureEquipped'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/linked-contents/5d314f3b-52fc-4c3a-90fe-33a96045c4fe/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/2e0d8a6e-8679-4e3c-8f39-1fbe06e7d37d/videos/2c0ba6a1-22f0-4ec0-8587-3d846173c6a5" target="_blank"><img src='images/Azure/LearningJourney/Equipped/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/linked-contents/210af55c-7598-4bcf-bc5a-03ce37171618/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/linked-contents/413c98bd-e69d-4540-a75d-2dc4095106ea/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/9d21c458-dd1b-4023-8983-b6ec252c5d71/videos/e392a610-0104-4ed9-a3c7-b07e2266041d" target="_blank"><img src='images/Azure/LearningJourney/Equipped/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/courses/091f6574-703f-4790-940a-6f8ec048ac03/videos/c36c6aff-00d5-4bec-a8b8-5ba78ee03969" target="_blank"><img src='images/Azure/LearningJourney/Equipped/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://accenture.percipio.com/courses/61cc1be0-6ee6-11e8-a814-671ad7cef381/videos/93b53560-6ee6-11e8-a814-671ad7cef381" target="_blank"><img src='images/Azure/LearningJourney/Equipped/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://accenture.percipio.com/linked-contents/bd1c054a-ad69-4297-9ddc-0cfc77b02f84/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://accenture.percipio.com/courses/b231d864-8662-4587-b06a-dc49b3b381de/videos/e8cbd599-bca9-4b81-a131-5f9f2ac32103" target="_blank"><img src='images/Azure/LearningJourney/Equipped/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/linked-contents/6ade7ab3-e2e1-4b08-acba-63749e086d6c/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/courses/91f00de6-b1f7-40e4-9f0b-f7e48fc1953f/videos/8479ac87-3828-414a-bfb2-e1c1202d16fa" target="_blank"><img src='images/Azure/LearningJourney/Equipped/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://accenture.percipio.com/courses/20b67a11-f7d2-4345-9ca2-f1c05949ed08/videos/8ba4f543-f5a9-4cee-bb4a-6cacda0db993" target="_blank"><img src='images/Azure/LearningJourney/Equipped/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a href="https://accenture.percipio.com/linked-contents/3a3c708e-d529-4f43-b454-e381048e7d53/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/13.png'/></a>
                    </p>
                    <p className='link14'>
                      <a href="https://accenture.percipio.com/linked-contents/84d918d5-d15e-425f-a7b2-9cc775b442ed/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/14.png'/></a>
                    </p>
                    <p className='link15'>
                      <a href="https://accenture.percipio.com/linked-contents/02188c5f-5f54-4fe3-8a52-9096e27ebf02/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/15.png'/></a>
                    </p>
                    <p className='link16'>
                      <a href="https://accenture.percipio.com/linked-contents/02188c5f-5f54-4fe3-8a52-9096e27ebf02/landing" target="_blank"><img src='images/Azure/LearningJourney/Equipped/16.png'/></a>
                    </p>
                    <p className='link17'>
                      <a href="https://accenture.percipio.com/courses/6c0d106d-8873-4307-8533-1e9fcf2a7da6/videos/20684efd-8922-473d-af29-070f4667c22b" target="_blank"><img src='images/Azure/LearningJourney/Equipped/17.png'/></a>
                    </p>
                  </div>
                  </div> */}
          <a
           href="https://connectedlearning.accenture.com/learningboard/1183772-microsoft-azure-paas-and-azure-data-services-equipped"
           target="_blank"
          >
           <img
            src="images/Azure/LearningJourney/Azure-Equipped.png"
            alt="Azure-equipped-img"
            className="lj-images"
           />
          </a>
         </div>
        </TabPanel>
        <TabPanel value="4" className="comingsoon" role="tabpanel">
         <div className="LJ-link-Wrapp">
          {/* <img src='images/Azure/LearningJourney/Competent/Azure-Competent-BG.png' alt='equipped-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='AzureCompetent'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/linked-contents/2bc9e3b2-3ba3-4295-bcee-4fb9a0d5c166/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/linked-contents/e98024f7-abb0-4993-9c9b-a26c8d77974e/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/d1bd166a-483b-4917-994b-e7363a8f685f/videos/a6444c6e-ede1-49cb-9b2f-2657444454c3" target="_blank"><img src='images/Azure/LearningJourney/Competent/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/linked-contents/7d8db393-41a9-4cb4-a0d6-2aabd01e7f08/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/linked-contents/5da8464f-ce58-41de-ac22-2f5aae2a0d9f/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/courses/06b75143-cbba-408a-ab46-edd8cb97b7f4/videos/979c582a-461a-4aa5-a273-30289f5b116e" target="_blank"><img src='images/Azure/LearningJourney/Competent/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://accenture.percipio.com/courses/91f00de6-b1f7-40e4-9f0b-f7e48fc1953f/videos/8479ac87-3828-414a-bfb2-e1c1202d16fa" target="_blank"><img src='images/Azure/LearningJourney/Competent/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://accenture.percipio.com/courses/629a8412-9439-4fcc-b55b-c02b6e369b93" target="_blank"><img src='images/Azure/LearningJourney/Competent/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://accenture.percipio.com/linked-contents/7cc71fe3-e2da-4a38-a03d-19cccf143f76/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/courses/2da88af5-6aa9-4c79-9574-14825d056666/videos/fe679227-4695-40ea-a624-f42769d6549c" target="_blank"><img src='images/Azure/LearningJourney/Competent/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/linked-contents/2191338f-a5b2-40bb-8b76-b49cd9543a0e/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://accenture.percipio.com/linked-contents/b7206f06-327e-4b82-9a77-0cc9c2173d9c/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a href="https://accenture.percipio.com/linked-contents/8b140825-f0ac-457f-85d5-7bd20e7d53ce/landing" target="_blank"><img src='images/Azure/LearningJourney/Competent/13.png'/></a>
                    </p>
                  </div>
                  </div> */}
          <a
           href="https://connectedlearning.accenture.com/learningboard/1183792-microsoft-azure-paas-and-azure-data-services-competent"
           target="_blank"
          >
           <img
            src="images/Azure/LearningJourney/Azure-Competent.png"
            alt="Azure-Competent-img"
            className="lj-images"
           />
          </a>
         </div>
        </TabPanel>
       </div>
      </TabContext>
     </Box>
    </div>
   </div>
  </>
 );
};
export default AzureLearningJourney;
